export default {
  createGroup: 'Create Group',
  creatingGroup: 'Creating group...',
  newGroup: 'New Group',
  name: 'Name',
  required: 'Required',
  create: 'Create',
  search: 'Search',
  manageGroupUsers: 'Manage group users',
  manageGroupModels: 'Manage group models',
  manageGroupReferences: 'Manage group references',
  manageGroupEkrms: 'Manage group EKRMs',
  deleteGroup: 'Delete group',
  warning: 'Warning',
  deletingGroup: 'Deleting group:',
  cannotBeUndone: 'This action cannot be undone. Are you sure?',
  cancel: 'Cancel',
  delete: 'Delete',
  usersForGroup: 'Users for group:',
  modelsForGroup: 'Models for group:',
  referencesForGroup: 'References for group:',
  ekrmsForGroup: 'EKRMs for group:',
  save: 'Save',
  abort: 'Abort',
  confirm: 'Confirm',
  processing: 'Processing...',
  userHeader: 'User',
  modelHeader: 'Model',
  typeHeader: 'Type',
  createdHeader: 'Created',
  referenceHeader: 'Reference',
  ekrmHeader: 'EKRM',
  adHoc: 'Ad-Hoc',
  custom: 'Custom',
  nameAlreadyUsed: 'Name already used'
}
